import { Mutex } from "async-mutex";
import { IStorage } from "./IStorage";

interface CacheStorage<DataType>
{
    version?: string;
    expires_at: Date;
    data: DataType;
}

export class CacheService<DataType>
{
    private name: string;
    private storage: IStorage;
    private duration_minutes: number;
    private getVersion: () => Promise<string>;
    private getFromSource: () => Promise<DataType>;
    public onExpired?: () => void;
    public runGetOn?: Mutex;
    constructor(name: string, storage: IStorage, duration_minutes: number, getVersion: () => Promise<string>, getFromSource: () => Promise<DataType>)
    {
        this.name = name;
        this.storage = storage;
        this.duration_minutes = duration_minutes;
        this.getVersion = getVersion;
        this.getFromSource = getFromSource;
    }
    async get(): Promise<DataType>
    {
        let innerGet = async () =>
        {
            let version = await this.getVersion();
            let value = this.storage.get(this.name, "");
            if (value)
            {
                let cache = JSON.parse(value) as CacheStorage<DataType>;
                if (cache.version == version)
                    if (new Date(cache.expires_at) > new Date())
                        return cache.data;
            }
            let ans = await this.getFromSource();
            await this.set(ans, version);
            return ans;
        };
        if (this.runGetOn)
            return await this.runGetOn.runExclusive(async () =>
            {
                return await innerGet();
            });
        return await innerGet();
    }
    async set(data: DataType, version?: string)
    {
        if (!version)
            version = await this.getVersion();
        let expires_at = new Date();
        expires_at.setMinutes(expires_at.getMinutes() + this.duration_minutes);
        let value = JSON.stringify({ data, version, expires_at });
        this.storage.set(this.name, value);

        if (this.onExpired)
        {
            let sleep = expires_at.getTime() - new Date().getTime();
            if (sleep <= 0)
                sleep = 5 * 1000;
            setTimeout(() =>
            {
                this.onExpired?.();
            }, sleep);
        }
    }
    del()
    {
        this.storage.del(this.name);
    }
}